module.exports = __webpack_public_path__ + "media/plant.13c45e7f.mp4";